import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { VendaAcessorioVeiculoComponent } from './venda-acessorio-veiculo.component';
import { VendaAcessorioVeiculoService } from './venda-acessorio/venda-acessorio-veiculo.service';
import { ComumModule } from '../../../shared/comum.module';
import { TranslateModule } from '@ngx-translate/core';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TooltipModule } from 'primeng/tooltip';
import { ChartsModule } from 'ng2-charts';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from 'primeng/progressbar';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { ContextMenuModule } from 'primeng/contextmenu';
import { MultiSelectModule } from 'primeng/multiselect';
import { SliderModule } from 'primeng/slider';
import { CalendarModule } from 'primeng/calendar';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TreeTableModule } from 'primeng/treetable';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { VendaAcessorioVeiculoFiltroService } from './venda-acessorio/venda-acessorio-veiculo-filtro.service';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    BrowserAnimationsModule,
    TreeTableModule,
    TableModule,
    ButtonModule,
    ToastModule,
    CalendarModule,
    SliderModule,
    MultiSelectModule,
    ContextMenuModule,
    DialogModule,
    DropdownModule,
    ProgressBarModule,
    InputTextModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    ChartsModule,
    NgbModule,
    TranslateModule.forRoot(translateLoaderNBS),
    TooltipModule
  ],
  declarations: [
    VendaAcessorioVeiculoComponent
  ],
  providers: [
    VendaAcessorioVeiculoService,
    VendaAcessorioVeiculoFiltroService,
    DatePipe
  ]
})

export class VendaAcessorioVeiculoModule { }
